import api from "@/core/api/axios";
import log from "loglevel";

export type UserConfirmationStatusResponse = {
  id: number;
  documentId: string;
  confirmed: boolean;
};

export const getUserConfirmationStatus = async (id: string) => {
  try {
    const response = await api().get<UserConfirmationStatusResponse>(
      `/users/${id}?fields=confirmed`
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    log.error(
      `Erro ao buscar status de confirmação para o usuário de id: ${id}:`,
      error
    );
    throw error;
  }
};
export const resendConfirmationEmail = async (email: string) => {
  try {
    const response = await api().post<{ sent: boolean }>(
      "/user/resend-confirmation-email",
      { email }
    );

    return response.data;
  } catch (error) {
    log.error(
      `Erro ao reenviar e-mail de confirmação para o endereço: ${email}:`,
      error
    );
    throw error;
  }
};

export const fetchAccountAccesses = async ({
  token,
}: {
  token: string | undefined;
}) => {
  try {
    const response = await api().get("/user/account-accesses", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data?.data || [];
  } catch (error) {
    log.error("Erro ao buscar acessos da conta:", error);
    throw error;
  }
};
